import { atom } from 'jotai';

import type {
  DeviceDialogMode,
  DeviceSizeDTO,
  DeviceTypeDTO
} from './DeviceCreate.types';

export const deviceDialogOpenAtom = atom(false);
export const deviceDialogModeAtom = atom<DeviceDialogMode>('New');
export const deviceTypesAtom = atom<DeviceTypeDTO[]>([]);
export const deviceSizeAtom = atom<DeviceSizeDTO[]>([]);
export const filteredDeviceSizeAtom = atom<DeviceSizeDTO[]>([]);
export const deviceTokenAtom = atom({});

export const hostNamePrefixAtom = atom('');
export const deviceNameAtom = atom('');
export const selectedDeviceTypeIdAtom = atom(0);
export const selectedDeviceSizeIdAtom = atom(0);
